import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'sl-default-layout',
    templateUrl: './default-layout.component.html',
    styleUrls: ['./default-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DefaultLayoutComponent {}
